import { memo } from "react";
import type { AssignDeviceBoxesProps } from "./types";

const SELECTED_COLOR = "#1d4ed8";
const OPEN_COLOR = "#475569";

export const AssignDeviceBoxes = memo(function AssignDeviceBoxes({ boxes }: AssignDeviceBoxesProps) {
  return (
    <g data-testid="assign-device-boxes">
      {boxes.map(({ key, bbox, color, state }) => {
        const width = Math.max(bbox.x2 - bbox.x1, 1);
        const height = Math.max(bbox.y2 - bbox.y1, 1);
        const isSelected = state === "selected";
        const isOpen = state === "open";
        return (
          <rect
            key={key}
            data-assign-box={state}
            x={bbox.x1}
            y={bbox.y1}
            width={width}
            height={height}
            rx={Math.min(width, height) * 0.12}
            fill={isSelected ? SELECTED_COLOR : isOpen ? "#ffffff" : color}
            fillOpacity={isSelected ? 0.3 : isOpen ? 0.55 : 0.32}
            stroke={isSelected ? SELECTED_COLOR : isOpen ? OPEN_COLOR : color}
            strokeWidth={isSelected ? 3.5 : 2}
            strokeDasharray={isOpen ? "5 3" : undefined}
            vectorEffect="non-scaling-stroke"
          />
        );
      })}
    </g>
  );
});
